import {
    mdiViewGridOutline,
    mdiAccountDetailsOutline,
    mdiLockOutline,
    mdiCardAccountDetailsOutline,
    mdiPostOutline,
    mdiBellOutline,
    mdiShareVariant,
  mdiClipboardClockOutline,
  mdiAccountKeyOutline,
} from '@mdi/js'

export default [
    {
        title: '应用中心',
        icon: mdiViewGridOutline,
        to: 'adhibition'
    },
    {
        title: '个人资料',
        icon: mdiAccountDetailsOutline,
        to: 'personalData',
    },
  // {
  //   title: '应用权限委托',
  //   icon: mdiShareVariant,
  //   to: 'authorization',
  // },
    {
        title: '账号安全',
        icon: mdiLockOutline,
        to: 'account',
    },
    {
        title: '个人偏好',
        icon: mdiCardAccountDetailsOutline,
        to: 'preference',
    },
    {
        title: '操作记录',
        icon: mdiPostOutline,
        to: 'log',
    },
    {
        title: '消息通知',
        icon: mdiBellOutline,
        to: 'inform',
    },
  // {
  //   title: '我的待办',
  //   icon: mdiClipboardClockOutline,
  //   to: 'todo',
  // },
  {
    title: '零信任办公',
    icon: mdiAccountKeyOutline,
    to: 'zeroTrust',
  },
]

